import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2091189388346525';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      // Standard Meta Pixel base code — wrapped in try/catch so any
      // sandbox/iframe issue can't break the page render.
      if (!window.fbq) {
        const f: any = window;
        const b = document;
        const n: any = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        f.fbq = n;
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = b.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
          firstScript.parentNode.insertBefore(t, firstScript);
        } else {
          b.head.appendChild(t);
        }
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (err) {
      // Silently fail — pixel must never break the page
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <noscript data-id="element-113">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-114" />
    </noscript>;
}